import { render, staticRenderFns } from "./RichTextView.vue?vue&type=template&id=3db235f4&scoped=true&"
import script from "./RichTextView.vue?vue&type=script&lang=ts&"
export * from "./RichTextView.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextView.vue?vue&type=style&index=0&id=3db235f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db235f4",
  null
  
)

export default component.exports